import { ProjectType as ProjectApiType } from 'src/api/generated/touring/types';
import {
  mapLinkableEntityType,
  mapMoneyType,
  mapShowWithTourType,
} from '../common';
import { mapArrangementType } from './helpers';
import { ProjectType } from './types';

export const mapProjectType = (apiType: ProjectApiType): ProjectType => {
  return {
    id: apiType.id,
    show: mapShowWithTourType(apiType.show),
    agencyContact: apiType.agencyContact
      ? mapLinkableEntityType(apiType.agencyContact)
      : null,
    unit: apiType.unit ?? null,
    projectNumber: apiType.projectNumber ?? null,
    sellable: apiType.sellable ?? null,
    artistGuarantee: apiType.artistGuarantee
      ? mapMoneyType(apiType.artistGuarantee)
      : null,
    vsArtistPercent: apiType.vsArtistPercent ?? null,
    vsTicketPercent: apiType.vsTicketPercent ?? null,
    dealStatus: apiType.dealStatus,
    faceValue: apiType.faceValue ? mapMoneyType(apiType.faceValue) : null,
    coPro: apiType.coPro ? mapLinkableEntityType(apiType.coPro) : null,
    deal: apiType.deal ?? null,
    arrangedBy: apiType.arrangedBy
      ? mapLinkableEntityType(apiType.arrangedBy)
      : null,
    arrangement: apiType.arrangement
      ? mapArrangementType(apiType.arrangement)
      : null,
    soldGage: apiType.soldGage ? mapMoneyType(apiType.soldGage) : null,
    promotedGuarantee: apiType.promotedGuarantee
      ? mapMoneyType(apiType.promotedGuarantee)
      : null,
    profitShare: apiType.profitShare ?? null,
    lossShare: apiType.lossShare ?? null,
    buyer: apiType.buyer ? mapLinkableEntityType(apiType.buyer) : null,
  };
};
